import { useFirestore } from '../../hooks/useFirestore'
// styles
import './Home.css'

// components
import RecipeList from '../../components/RecipeList'

export default function Home() {
  const { data: recipes, isPending, error} = useFirestore('recipes')
  return (
    <div className="home">
      {error && <p className="error">{error}</p>}
      {isPending && <p className="loading">Loading...</p>}
      {recipes && <RecipeList recipes={recipes}/>}
    </div>
  )
}
